var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgEmptyUserAnalyticsTable = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 77,
    viewBox: "0 0 120 77",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 77,
    fill: "#E5E5E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Analytics - Most points received"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 2106,
    transform: "translate(-703 -787)",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 20833019"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 20832984"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1367",
    x: -435,
    y: -138,
    width: 976,
    height: 430,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 20833238"
  }, /*#__PURE__*/React.createElement("g", {
    id: "increase in org health"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 1818",
    d: "M8.03891 13.1158C-13.3257 38.1214 14.8243 60.4277 31.5699 68.4551C55.0648 79.718 104.916 84.6809 117.857 50.1114C132.229 11.7174 34.7447 -18.1413 8.03891 13.1158Z",
    fill: "#F4F5F7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 20833201"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 1870",
    d: "M44.5 23.999C44.5 24.2752 44.7239 24.499 45 24.499C45.2761 24.499 45.5 24.2752 45.5 23.999H44.5ZM45.3536 10.6455C45.1583 10.4502 44.8417 10.4502 44.6464 10.6455L41.4645 13.8275C41.2692 14.0227 41.2692 14.3393 41.4645 14.5346C41.6597 14.7298 41.9763 14.7298 42.1716 14.5346L45 11.7061L47.8284 14.5346C48.0237 14.7298 48.3403 14.7298 48.5355 14.5346C48.7308 14.3393 48.7308 14.0227 48.5355 13.8275L45.3536 10.6455ZM45.5 23.999V10.999H44.5V23.999H45.5Z",
    fill: "#8DD9BF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1871",
    d: "M33.5 31.999C33.5 32.2752 33.7239 32.499 34 32.499C34.2761 32.499 34.5 32.2752 34.5 31.999H33.5ZM34.3536 20.6455C34.1583 20.4502 33.8417 20.4502 33.6464 20.6455L30.4645 23.8275C30.2692 24.0227 30.2692 24.3393 30.4645 24.5346C30.6597 24.7298 30.9763 24.7298 31.1716 24.5346L34 21.7061L36.8284 24.5346C37.0237 24.7298 37.3403 24.7298 37.5355 24.5346C37.7308 24.3393 37.7308 24.0227 37.5355 23.8275L34.3536 20.6455ZM34.5 31.999V20.999H33.5V31.999H34.5Z",
    fill: "#8DD9BF",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 20833200"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3463906",
    x: 38,
    y: 35.999,
    width: 10,
    height: 22,
    fill: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3463907",
    x: 52,
    y: 22.999,
    width: 10,
    height: 35,
    fill: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3463908",
    x: 66,
    y: 13.999,
    width: 10,
    height: 44,
    fill: "#CECECE"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 20833190"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M63.3568 54.9364L73.25 67.499L83.1432 54.9364C87.2938 49.6659 81.1355 42.5561 75.2546 45.8288L73.25 46.9444L71.2454 45.8288C65.3645 42.5561 59.2062 49.6659 63.3568 54.9364Z",
    fill: "#16D090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1866",
    d: "M69.5 55.874L71.375 50.999L74 59.999L76.25 52.874L77.75 55.874H86",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  })))))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEmptyUserAnalyticsTable, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/empty-user-analytics-table.ace8a3e9.svg";
export { ForwardRef as ReactComponent };